import React, {useEffect, useRef, useState} from "react";
import styles from "./non-user-view-movie.module.css";
import texts from "../../assets/ContextProvider/textsLocalized.json";
import {useNavigate, useParams} from "react-router-dom";
import Routes from "../../assets/Routes/Routes";
import 'simplebar/dist/simplebar.min.css';
import SimpleBar from 'simplebar-react';
import {ReactComponent as Logo} from "../../components/Header/img/cinemAI-logo.svg";
import ServerRequest from "../../serverRequests/ServerRequest";
import Loader from "../../components/Loader/Loader";
import {scrollToTop} from "../../assets/AdditionalFunctions/ScrollToTop";
import {animateButtonPress} from "../../assets/AdditionalFunctions/AnimateButtonPress";
import {handleFormatReleaseDate} from "../../assets/AdditionalFunctions/FormattingMovieReleaseDate";


const NonUserViewMovie = () => {
  const [isLoading, setIsLoading] = useState(false);
  const {token} = useParams();
  const [card, setCard] = useState(null);
  const navigate = useNavigate();
  const btnRef = useRef(null);


  useEffect(() => {
    const fetchCard = async () => {
      try {
        const serverData = await ServerRequest.getSharedCard(token);
        const parsedServerData = await serverData.json();

        if (parsedServerData.code !== 200) {
          navigate(Routes.login);
        }

        if (parsedServerData.code === 200) {
          setCard(parsedServerData.card);
        } else {
          console.error(parsedServerData.message);
        }
      } catch (error) {
        console.error(error);
      }
    }

    fetchCard();

  }, [token]);


  useEffect(() => {
    setIsLoading(!card);
  }, [card]);


  useEffect(() => {
    scrollToTop();
  }, []);


  const handleNavigate = async () => {
    await animateButtonPress(btnRef, styles.pressed);
    window.location.href = "https://clnemai.com/";
  }


  return (
    <section className={styles["movies-container"]}>
      <Loader isLoading={isLoading}/>
      {card &&
        <>
          <Logo className={styles["main-logo"]}
                width={235}
                height={52}/>

          <div className={styles['movie-card']}>
            <div className={styles['movie-first-block']}>
              <img className={styles['movie-poster']}
                   src={card['poster_url'] ? card['poster_url'] : require("./img/no-poster.png")}
                   alt="image poster"/>
              <div className={styles['movie-first-block-description']}>
                <div>
                  <div className={styles["movie-first-section"]}>
                    <p className={styles['first-block-description-title']}>
                      {card.name.length < 40 ? card.name
                        : card.name.substring(0, 40).concat('...')}
                    </p>
                  </div>
                  {/*<div className={styles["movie-second-section"]}>*/}
                  {/*  <div className={styles['director-info-container']}>*/}
                  {/*    <p className={styles['director-info-title']}>*/}
                  {/*      {texts.movies['movies-director']}:*/}
                  {/*      <span className={styles['director-info-title-value']} lang="en-GB">*/}
                  {/*        {card.director ? card.director : 'not found'}*/}
                  {/*      </span>*/}
                  {/*    </p>*/}
                  {/*  </div>*/}
                  {/*  <p className={styles['release-date']}>*/}
                  {/*    {handleFormatReleaseDate(card.releaseDate)}*/}
                  {/*  </p>*/}
                  {/*</div>*/}
                </div>
                <div className={styles["movie-third-section"]}>
                  {card.genres.map((genre, index) => {
                    return (
                      <div className={styles['movie-genre']} key={index}>
                        {genre}
                      </div>
                    )
                  }).slice(0, 3)}
                </div>
              </div>
            </div>
            <div className={styles['movie-second-block']}>
              <div className={styles["movie-second-block--first"]}>
                <div className={styles["movie-second-section"]}>
                  <div className={styles['director-info-container']}>
                    <p className={styles['director-info-title']}>
                      {texts.movies['movies-director']}:
                      <span className={styles['director-info-title-value']}>
                        {card.director ? card.director : 'not found'}
                      </span>
                    </p>
                  </div>
                  <div className={styles['release-date-info-container']}>
                    <p className={styles['release-date-title']}>
                      {texts.movies['movies-release-date']}:
                      <span className={styles['release-date']}>
                              {handleFormatReleaseDate(card.releaseDate)}
                            </span>
                    </p>
                  </div>
                </div>
              </div>
              <div className={styles["movie-second-block--second"]}>
                <div className={styles['movie-duration']}>
                  <span className={styles['movie-duration-title']}>
                    {texts.movies['movies-duration-title']}:
                  </span>
                  <span className={styles['movie-duration-value']}>
                    {card.duration ? card.duration : 'not found'}
                  </span>
                </div>
                <div className={styles['movie-rating']}>
                  <span className={styles['movie-rating-title']}>
                    {texts.movies['movies-rating-title']}:
                  </span>
                  <span className={styles['movie-rating-value']}>
                  {Number(card.ratingIMDb.toFixed(1))}
                  </span>
                  <img className={styles['movie-rating-star']}
                       src={require("./img/rating.png")}
                       alt="image rating star"/>
                </div>
              </div>
            </div>
            {/*<div className={styles['movie-second-block']}>*/}
            {/*  <div className={styles['movie-duration']}>*/}
            {/*      <span className={styles['movie-duration-title']}>*/}
            {/*        {texts.movies['movies-duration-title']}:*/}
            {/*      </span>*/}
            {/*    <span className={styles['movie-duration-value']}>*/}
            {/*      {card.duration ? card.duration : 'not found'}*/}
            {/*      </span>*/}
            {/*  </div>*/}
            {/*  <div className={styles['movie-rating']}>*/}
            {/*      <span className={styles['movie-rating-title']}>*/}
            {/*        {texts.movies['movies-rating-title']}:*/}
            {/*      </span>*/}
            {/*    <span className={styles['movie-rating-value']}>*/}
            {/*      {Number(card.ratingIMDb.toFixed(1))}*/}
            {/*      </span>*/}
            {/*    <img className={styles['movie-rating-star']}*/}
            {/*         src={require("./img/rating.png")}*/}
            {/*         alt="image rating star"/>*/}
            {/*  </div>*/}
            {/*</div>*/}
            <div className={styles['movie-third-block']}>
              <p className={styles['main-actors']}>
                {texts.movies['main-actors-title']}: {(card.mainActors.length < 1) &&
                <span className={styles['not-found']}>not found</span>}
              </p>
              <p className={styles['movie-actor']}>
                {card.mainActors ? card.mainActors.join(", ") : null}
              </p>
            </div>
            <div className={styles['movie-fourth-block']}>
              <p className={styles['review']}>
                {texts.movies['review']}: {!card.review &&
                <span className={styles['not-found']}>not found</span>}
              </p>
              {(card.review && card.review.length > 240) ?
                <SimpleBar className={styles['movie-review']}>
                  {card.review ? card.review : 'not found'}
                </SimpleBar> :
                (card.review && card.review.length <= 240) ?
                  <div
                    className={styles['movie-review-without-scroll']}>
                    {card.review ? card.review : 'not found'}
                  </div> : null
              }
            </div>
          </div>

          <p className={styles['sharing-movie-notice']}>
            {texts['sharing-movie']['sharing-movie-notice']}
          </p>
          <button ref={btnRef}
                  className={styles['continue-button']}
                  onClick={handleNavigate}>
            {texts['sharing-movie']['sharing-movie-btn']}
          </button>
        </>
      }
    </section>
  );
}

export default NonUserViewMovie;